import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { InformationHeader } from "src/app/_models/InformationHeader";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectUserInformationHeaders } from "src/app/_store/user-profile/user-profile.selectors";
import { AppConstants } from "src/app/constants/constants";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();
  @Input() isAdmin: boolean;
  @Input() isTutor: boolean;
  @Input() isSystemAdmin: boolean;
  @Input() loginDisplay: boolean;
  informationHeader$: Observable<InformationHeader>;
  isDevEnvironment: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  ngOnInit(): void {
    this.isDevEnvironment = this.config.isDevEnvironment;
    this.selectorUserInformationHeader();

    if (this.loginDisplay) {
      this.dispatchOwnUserProfile();
    }
  }

  dispatchOwnUserProfile(): void {
    this.store.dispatch(GetOwnUserProfile());
  }

  selectorUserInformationHeader(): void {
    this.informationHeader$ = this.store.select(selectUserInformationHeaders);
  }
  public onSidenavClose = () => {
    this.sidenavClose.emit();
  };

  goto(page: string): void {
    this.router.navigate([AppConstants.ADMIN_PAGE, page], {
      relativeTo: this.route,
    });

    this.onSidenavClose();
  }

  gotoTutorPage(page: string): void {
    this.router.navigate([AppConstants.TUTOR_PAGE, page], {
      relativeTo: this.route,
    });

    this.onSidenavClose();
  }
}
